import React, { useEffect } from 'react';
import { ReactComponent as AIConsultingIcon } from '../assets/images/ai-consulting.svg';
import { ReactComponent as ChatbotIcon } from '../assets/images/chatbot.svg';
import { ReactComponent as DataAnalyticsIcon } from '../assets/images/data-analytics.svg';
import { ReactComponent as MarketingIcon } from '../assets/images/marketing.svg';

const Services = () => {
  const services = [
    {
      icon: <AIConsultingIcon />,
      title: 'AI Consulting',
      description: 'Strategic guidance on implementing AI solutions tailored to your business needs.',
      className: 'ai-consulting-service'
    },
    {
      icon: <ChatbotIcon />,
      title: 'Conversational AI (Chatbots)',
      description: '24/7 advanced support chatbots and natural AI voice assistants',
      className: 'chatbot-service'
    },
    {
      icon: <DataAnalyticsIcon />,
      title: 'Data Analytics',
      description: 'Comprehensive data analysis to drive informed business decisions and uncover valuable insights.',
      className: 'data-analytics-service'
    },
    {
      icon: <MarketingIcon />,
      title: 'Marketing',
      description: 'AI-powered marketing strategies to boost engagement, conversions, and ROI.',
      className: 'marketing-service'
    }
  ];
  
  // Generate binary code for the rain effect
  useEffect(() => {
    const binaryRain = document.querySelector('.binary-rain');
    if (binaryRain) {
      for (let i = 0; i < 10; i++) {
        const column = document.createElement('div');
        column.className = 'binary-column';
        
        // Generate random binary string
        let binaryString = '';
        for (let j = 0; j < 30; j++) {
          binaryString += Math.random() > 0.5 ? '1' : '0';
          binaryString += '<br>';
        }
        
        column.innerHTML = binaryString;
        binaryRain.appendChild(column);
      }
    }
    
    // Generate circuit nodes at intersections
    const servicesSection = document.querySelector('.services');
    if (servicesSection) {
      const circuitContainer = document.querySelector('.services-circuit');
      if (circuitContainer) {
        // Create nodes at intersections of horizontal and vertical lines
        const horizontalPositions = [15, 35, 65, 85]; // percentages
        const verticalPositions = [20, 40, 60, 80]; // percentages
        
        horizontalPositions.forEach(y => {
          verticalPositions.forEach(x => {
            const node = document.createElement('div');
            node.className = 'circuit-node';
            node.style.top = `${y}%`;
            node.style.left = `${x}%`;
            node.style.animationDelay = `${Math.random() * 5}s`;
            circuitContainer.appendChild(node);
          });
        });
      }
    }
  }, []);

  return (
    <section id="services" className="services">
      {/* Enhanced animated background elements */}
      <div className="services-bg-grid"></div>
      
      {/* Digital circuit lines */}
      <div className="services-circuit">
        <div className="circuit-line"></div>
        <div className="circuit-line"></div>
        <div className="circuit-line"></div>
        <div className="circuit-line"></div>
        <div className="circuit-vertical"></div>
        <div className="circuit-vertical"></div>
        <div className="circuit-vertical"></div>
        <div className="circuit-vertical"></div>
        {/* Circuit nodes will be added by JS */}
      </div>
      
      {/* Binary code rain effect */}
      <div className="binary-rain">
        {/* Binary columns will be added by JS */}
      </div>
      
      {/* Tech symbols */}
      <div className="services-tech-symbol">AI</div>
      <div className="services-tech-symbol">ML</div>
      <div className="services-tech-symbol">NLP</div>
      <div className="services-tech-symbol">CV</div>
      <div className="services-tech-symbol">DL</div>
      
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className={`service-card ${service.className || ''}`} key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services; 